<template>
  <!--  BEGIN NAVBAR  -->
  <div class="header-container fixed-top">
    <header class="header navbar navbar-expand-sm">
      <ul class="navbar-item theme-brand flex-row text-center">
        <li class="nav-item theme-logo">
          <Link href="/dashboard">
            <img src="../../../assets/images/asklaLogo-nb-white.png" class="navbar-logo" alt="logo"/>
          </Link>
        </li>
      </ul>

      <div class="navbar-item flex-row ms-md-auto">
        <div class="dark-mode d-flex align-items-center">
          <a v-if="$store.state.dark_mode === 'light'" href="javascript:" class="d-flex align-items-center"
             @click="toggleMode('dark')">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-sun"
            >
              <circle cx="12" cy="12" r="5"></circle>
              <line x1="12" y1="1" x2="12" y2="3"></line>
              <line x1="12" y1="21" x2="12" y2="23"></line>
              <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
              <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
              <line x1="1" y1="12" x2="3" y2="12"></line>
              <line x1="21" y1="12" x2="23" y2="12"></line>
              <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
              <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
            </svg>
            <span class="ms-2">Jasny</span> </a>
          <a v-if="$store.state.dark_mode === 'dark'" href="javascript:" class="d-flex align-items-center"
             @click="toggleMode('light')">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-moon"
            >
              <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
            </svg>
            <span class="ms-2">Ciemny</span> </a>
        </div>


        <PushNotifications></PushNotifications>


        <div class="dropdown nav-item user-profile-dropdown btn-group">
          <a href="#" id="ddluser" data-bs-toggle="dropdown" aria-expanded="false"
             class="btn dropdown-toggle btn-icon-only user nav-link">
            <i class="bi bi-person" style="color: white; font-size: 1.3rem"></i>
          </a>
          <ul class="dropdown-menu dropdown-menu-right m-0" aria-labelledby="ddluser">
            <li role="presentation">
              <Link href="/profile" class="dropdown-item">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="feather feather-user"
                >
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
                Konto
              </Link>
            </li>
            <li role="presentation">
              <Link href="/logout" method="post" class="dropdown-item" as="button">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="feather feather-log-out"
                >
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                  <polyline points="16 17 21 12 16 7"></polyline>
                  <line x1="21" y1="12" x2="9" y2="12"></line>
                </svg>
                Wyloguj
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </header>
  </div>
  <!--  END NAVBAR  -->
  <!--  BEGIN NAVBAR2  -->
  <div class="sub-header-container">
    <header class="header navbar navbar-expand-sm">
      <a href="javascript:void(0);" class="sidebarCollapse" data-placement="bottom"
         @click="$store.commit('toggleSideBar', !$store.state.is_show_sidebar)">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="feather feather-menu"
        >
          <line x1="3" y1="12" x2="21" y2="12"></line>
          <line x1="3" y1="6" x2="21" y2="6"></line>
          <line x1="3" y1="18" x2="21" y2="18"></line>
        </svg>
      </a>

      <!-- Breadcrumb -->
      <Breadcrumbs/>

      <!-- SLOT -->
      <div class="ms-auto d-flex align-items-center gap-3">
        <slot name="subheader"></slot>
      </div>


    </header>
  </div>
  <!--  END NAVBAR  -->
  <!--  BEGIN TOPBAR  -->
  <div class="topbar-nav header navbar" role="banner">
    <nav class="topbar">
      <ul class="list-unstyled menu-categories" id="topAccordion">
        <li class="menu single-menu">
          <a href="javascript:" class="dropdown-toggle autodroprown">
            <div class="">
              <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-home"
              >
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                <polyline points="9 22 9 12 15 12 15 22"></polyline>
              </svg>
            </div>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-chevron-down"
            >
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </a>
          <ul class="collapse submenu list-unstyled"></ul>
        </li>
      </ul>
    </nav>
  </div>
  <!--  END TOPBAR  -->
</template>

<script setup>
import {onMounted} from "vue";
import FlashNotifications from "@/Components/FlashNotifications.vue";

onMounted(() => {
  toggleMode();
});
const toggleMode = (mode) => {
  window.$appSetting.toggleMode(mode);
};

</script>
<script>
import {useStore} from "vuex";
import {Link} from "@inertiajs/vue3";
import PushNotifications from "@/Components/PushNotifications.vue";
import Breadcrumbs from '@/Components/Layout/Breadcrumbs.vue';

export default {
  components: {Link, Breadcrumbs, PushNotifications},

  setup() {
    const store = useStore();
    return {store}
  },
}
</script>
